import { SVGProps } from "react";
import { JSX } from "react/jsx-runtime";

export function Ticket(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={42}
      height={42}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.75 17.5v1a1 1 0 001-1h-1zm0 7h1a1 1 0 00-1-1v1zm-31.5 0v-1a1 1 0 00-1 1h1zm0-7h-1a1 1 0 001 1v-1zm3.5-9.75a4.5 4.5 0 00-4.5 4.5h2a2.5 2.5 0 012.5-2.5v-2zm24.5 0H8.75v2h24.5v-2zm4.5 4.5a4.5 4.5 0 00-4.5-4.5v2a2.5 2.5 0 012.5 2.5h2zm0 5.25v-5.25h-2v5.25h2zm-3.5 3.5a2.5 2.5 0 012.5-2.5v-2a4.5 4.5 0 00-4.5 4.5h2zm2.5 2.5a2.5 2.5 0 01-2.5-2.5h-2a4.5 4.5 0 004.5 4.5v-2zm1 6.25V24.5h-2v5.25h2zm-4.5 4.5a4.5 4.5 0 004.5-4.5h-2a2.5 2.5 0 01-2.5 2.5v2zm-24.5 0h24.5v-2H8.75v2zm-4.5-4.5a4.5 4.5 0 004.5 4.5v-2a2.5 2.5 0 01-2.5-2.5h-2zm0-5.25v5.25h2V24.5h-2zm3.5-3.5a2.5 2.5 0 01-2.5 2.5v2a4.5 4.5 0 004.5-4.5h-2zm-2.5-2.5a2.5 2.5 0 012.5 2.5h2a4.5 4.5 0 00-4.5-4.5v2zm-1-6.25v5.25h2v-5.25h-2z"
        fill={props.color}
      />
      <path
        d="M26.25 8.75v3.5"
        stroke={props.color}
        strokeWidth={2.625}
        strokeLinecap="round"
      />
      <path
        d="M26.25 19.25v3.5M26.25 29.75v3.5"
        stroke={props.color}
        strokeWidth={2.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
